<template>
	<v-form class="py-2" ref="form" lazy-validation>
		<v-divider />
		<h2 class="mt-4 font-weight-bold text-subtitle-1">コメントを追加</h2>
		<v-textarea
			v-model="content"
			label="コメント（必須）"
			class="mt-4"
			:hide-details="true"
			outlined
			:rules="[rules.required]"
		/>

		<div class="mt-4">
			<label class="text-body-2 font-weight-bold">アイコン</label>
			<div class="mt-2">
				<span
					:class="`emotion-icon ${emotionClass(option)}`"
					v-for="option in emotionOptions"
					:key="option"
					@click="emotion = option"
				>
					<i :class="`far fa-2x fa-${option}`" />
				</span>
			</div>
		</div>

		<div class="form-field mt-4">
			<label class="text-body-2 font-weight-bold d-block">添付</label>
			<v-btn color="secondary" class="mt-2 font-weight-bold" @click="$refs.uploadFile.click()">
				<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
				添付ファイルを追加する
				<input
					type="file"
					class="display-none"
					ref="uploadFile"
					@change="addFiles($event)"
					multiple
				/>
			</v-btn>

			<div class="file-area mt-2">
				<span v-if="files.length < 1" class="filename text-body-2">選択されていません</span>
				<template v-else>
					<v-chip
						class="ma-1 mt-2"
						close
						label
						outlined
						color="primary"
						@click:close="removeFile(i)"
						v-for="(file, i) in files"
						:key="file.name"
					>
						<v-icon class="mr-1">mdi-paperclip</v-icon>
						{{ file.name }}
					</v-chip>
				</template>
			</div>
		</div>
		<v-row justify="center" class="pa-0 ma-0 mt-4">
			<v-btn color="secondary" dark @click="createComment">コメントする</v-btn>
		</v-row>
	</v-form>
</template>

<script>
import axios from "axios"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"

export default {
	props: ["report_id"],
	data() {
		return {
			rules: rules,
			emotion: "",
			content: null,
			files: [],
			emotionOptions: ["grin", "angry", "frown", "dizzy", "laugh", "meh", "surprise", "smile-wink"],
			comment: null,
		}
	},
	methods: {
		createComment() {
			if (!this.$refs.form.validate()) return
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_reports/${this.report_id}/daily_report_comments`
			axios
				.post(
					url,
					{
						daily_report_comment: {
							emotion: this.emotion,
							content: this.content,
						},
					},
					{ headers }
				)
				.then((res) => {
					this.comment = res.data
					if (!this.files.length) return this.successUpload()
					const fileCount = 0
					this.uploadFiles(this.comment.id, fileCount)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		removeFile(index) {
			this.files.splice(index, 1)
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		uploadFiles(id, fileCount) {
			let formData = new FormData()
			formData.append("daily_report_comment[file]", this.files[fileCount])
			let headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_comments/${id}/daily_report_comment_files`
			headers["content-type"] = "multipart/form-data"
			axios
				.post(url, formData, { headers })
				.then((res) => {
					this.comment.files_with_url.push(res.data)
					if (this.files.length == fileCount + 1) return this.successUpload()
					this.uploadFiles(id, fileCount + 1)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		successUpload() {
			this.$store.dispatch("setFlash", {
				type: "notice",
				text: "コメントしました。",
			})
			this.$emit("add-comment", this.comment)
			this.$refs.form.reset()
			this.comment = null
			this.emotion = null
			this.files = []
		},
	},
	computed: {
		emotionClass() {
			return (option) => {
				return option == this.emotion ? "emotion-icon--selected" : ""
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";
.display-none {
	display: none;
}
.emotion-icon {
	display: inline-block;
	margin-left: 4px;
	color: grey;
	cursor: pointer;
	&:hover {
		opacity: 0.7;
	}
	&--selected {
		color: $main-color;
	}
}
</style>